var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "persistent",
        fullscreen: "fullscreen",
        eager: "eager",
        transition: "dialog-bottom-transition"
      },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-toolbar",
        { attrs: { color: _vm.toolbarColor, dark: "dark" } },
        [
          _c("v-icon", {
            staticClass: "mr-2",
            domProps: { innerHTML: _vm._s(_vm.toolbarIcon) }
          }),
          _c("span", [_vm._v("Voucher Info")]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { text: "text" },
              on: {
                click: function($event) {
                  _vm.openDialog = false
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-container",
            { attrs: { fluid: "fluid" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Voucher",
                                  text: _vm.data.voucher_no
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Date",
                                  text: _vm.data.date.dateFormat()
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("base-card", {
                                attrs: { title: "Status", text: _vm.status }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Project Code",
                                  text: _vm.projectCode
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Budget Code",
                                  text: _vm.budgetCode
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Created By",
                                  text: _vm.requestor
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: { title: "Paid By", text: _vm.paidBy }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Cost Center",
                                  text: _vm.costCenter
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: { title: "Pay To", text: _vm.payTo }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Address",
                                  text: _vm.data.address
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.approvedOrRejected
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "green",
                                        dense: "dense",
                                        small: "small",
                                        dark: "dark",
                                        loading: _vm.approving
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "approve",
                                            _vm.data.id
                                          )
                                        }
                                      }
                                    },
                                    [_c("span", [_vm._v("Approve")])]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "red",
                                        dense: "dense",
                                        small: "small",
                                        dark: "dark",
                                        loading: _vm.rejecting
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "reject",
                                            _vm.data.id
                                          )
                                        }
                                      }
                                    },
                                    [_c("span", [_vm._v("Reject")])]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "5" } },
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Account Code")]),
                                    _c("th", [_vm._v("Reason")]),
                                    _c("th", { staticClass: "text-right" }, [
                                      _vm._v("Amount")
                                    ])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.data.details, function(item) {
                                      return _c("tr", { key: item.id }, [
                                        _c("td", [
                                          item.account_code
                                            ? _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text mr-2"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.account_code
                                                          .account_code
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "blue-grey--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.account_code
                                                          .description
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        _c("td", [_vm._v(_vm._s(item.reason))]),
                                        _c(
                                          "th",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(item.amount.phpFormat())
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    _c("tr", [
                                      _c("th", { attrs: { colspan: "2" } }, [
                                        _vm._v("Total")
                                      ]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(_vm.totalAmount.phpFormat())
                                        )
                                      ])
                                    ])
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Acct Code")]),
                                    _c("th", { staticClass: "text-right" }, [
                                      _vm._v("Disbursed Amount")
                                    ]),
                                    _c("th", { staticClass: "text-right" }, [
                                      _vm._v("Amount")
                                    ]),
                                    _c("th", { staticClass: "text-right" }, [
                                      _vm._v("Balance")
                                    ])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.data.account_codes, function(
                                      item
                                    ) {
                                      return _c("tr", { key: item.id }, [
                                        _c("td", [
                                          item.account_code
                                            ? _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text mr-2"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.account_code
                                                          .account_code
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "blue-grey--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.account_code
                                                          .description
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        _c(
                                          "th",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                Number(
                                                  item.disbursed_amount
                                                ).phpFormat()
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "th",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(item.amount.phpFormat())
                                            )
                                          ]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-right",
                                            class:
                                              item.balance < 0 && "red--text"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.balance.phpFormat()
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    _vm.data.revolving_fund
                                      ? _c("tr", [
                                          _c("th", [_vm._v("--.--")]),
                                          _c(
                                            "th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.revolvingFundDisbursedAmount.phpFormat()
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            { staticClass: "text-right" },
                                            [_vm._v(_vm._s((0).phpFormat()))]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-right red--text"
                                            },
                                            [
                                              _vm._v(
                                                " -" +
                                                  _vm._s(
                                                    _vm.revolvingFundDisbursedAmount.phpFormat()
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("tr", [
                                      _c("th", [_vm._v("Total")]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalDisbursedAmount.phpFormat()
                                          )
                                        )
                                      ]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(_vm.totalAmount.phpFormat())
                                        )
                                      ]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(_vm.totalBalance.phpFormat())
                                        )
                                      ])
                                    ])
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }